import React from 'react';
import { SystemMessage } from './SystemMessage';
export var SystemMessageGroup = function SystemMessageGroup(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "messages__grouping"
  }, /*#__PURE__*/React.createElement("div", {
    className: "system-message-list"
  }, props.messages.map(function (message) {
    return /*#__PURE__*/React.createElement(SystemMessage, {
      key: message.id,
      message: message,
      actions: props.actions
    });
  })));
};